<script>
    import {Report, Toolbar, LinkButton} from '@manaakiwhenua/frag-svelte/src/index'
    import {default as Footer} from './report-sections/Footer.svelte';
    import {createEventDispatcher} from "svelte";
    import { MaoriFactsheetAPI } from "./api";
    import {
        Header,
        SoilClassification,
        SoilHorizons,
        SoilPhysicalProperties,
        SoilChemicalProperties,
        SoilManagementFactors,
        LandformHeader,
        Landform
    } from "./maoriReportSections";
    import Heading from "./maoriReportSections/Heading.svelte";
    import Preramble from "./maoriReportSections/Preramble.svelte";
    import {headingFromData} from "./maoriReportSections/util";
    import KumaraSuitability from "./maoriReportSections/KumaraSuitability.svelte";

    export let gisLayer;
    export let soilMapUnitCode;
    export let siblingNumber = 1;
    export let objectId;
    export let reportLink = '';
    export let pinCoordinate;
    export let printLink = '';
    export let licence = undefined;
    export let factsheetApiUrl = undefined;

    let isTeReo = true;

    const dispatch = createEventDispatcher();

    function closeReport() {
        dispatch('closeReport');
    }

    const linkButtonClass = 'btn btn-info no-box-shadow';

    $: params = {
        gisLayer, soilMapUnitCode, smapHubSiblingRankOrder: siblingNumber, isMaori: isTeReo
    }

    let retries = 1;

    $: api = new MaoriFactsheetAPI(factsheetApiUrl);

    $: dataSpatial = retries && api.spatial(params);
    $: dataLandform = retries && api.landform(params).then(resp => Object.entries(resp).length ? resp : null);

    $: kumaraSuitabilityData = objectId && retries
        ? api.kumara(objectId, siblingNumber).then(data => data.find(d => `${d.siblingRankOrder}` === `${siblingNumber}`))
        : Promise.reject('No ObjectId or retries exhausted');

</script>

<style>
    a.print-link {
        display: inline-block;
        color: white;
    }

    a.print-link:hover {
        text-decoration: none;
    }

    /*.language-btn {
        color: white;
        line-height: 2em;
        padding: 0.25em 0.5em;
        border-radius: 5px;
        margin: 0;
    }

    .language-btn:hover {
        background-color: #333A3A;
    }*/

    [slot="header"] {
        padding: 0 1em;
    }

    [slot="extraButtons"] {
        color: white;
    }

    /*.sep {
        border-right: 2px solid white;
        height: 2em;
    }*/

    [slot="extraButtons"] {
        display: flex;
        align-items: center;
        justify-items: center;
    }
</style>

<Report categories={[]}>
    <div slot="toolbar">
        <Toolbar printEnabled={!printLink}>
            <div slot="extraButtons">
                <!--<button class="language-btn div-like" on:click={() => isTeReo = !isTeReo}>
                    {#if isTeReo}
                        Te reo
                    {:else}
                        English
                    {/if}
                </button>-->
                <!--<span class="sep"></span>-->
                <LinkButton link={reportLink} buttonClass={linkButtonClass}/>
                {#if printLink}
                    <a href={printLink}
                       class="print-link"
                       target="_blank"
                       title="Printable version of this factsheet">
                        <i class="icon icon-print"></i>
                    </a>
                {/if}
            </div>
            <button class="div-like" slot="closeButton" on:click={closeReport}>
                <i class="close-button icon icon-close_large"></i>
            </button>
        </Toolbar>
    </div>

    <div slot="header">
        {#await dataSpatial}
            <p>loading...</p>
        {:then data}
            {#if data && data.value && data.header}
                <Header dataMapped={dataSpatial}/>

                <Preramble/>

                <LandformHeader dataMapped={dataSpatial}/>
                {#await dataLandform then landformData}
                    {#if landformData}
                        <Landform dataMapped={dataSpatial} dataLandformMapped={dataLandform}/>
                    {:else}
                        <p>No landform data.</p>
                    {/if}
                {:catch ex}
                {/await}

                <Heading>
                    { headingFromData(data, 1, 'Te whakamārama mō te āhua o te oneone (Description of the soil)') }
                </Heading>

                <SoilClassification dataMapped={data}/>

                <SoilHorizons dataMapped={dataSpatial}/>

                <SoilPhysicalProperties dataMapped={dataSpatial}/>
                <SoilChemicalProperties dataMapped={dataSpatial}/>
                <SoilManagementFactors dataMapped={dataSpatial}/>

                <Heading>
                    Kūmara suitability
                </Heading>

                {#await kumaraSuitabilityData}
                    <p>loading...</p>
                {:then kumaraData}
                    {#if kumaraData}
                        <KumaraSuitability data={kumaraData}/>
                    {:else}
                        <p>No kūmara suitability data found.</p>
                    {/if}
                {:catch e}
                    <p>Failed to load kūmara data.</p>
                {/await}

            {:else}
                <p>No data available.</p>
            {/if}


        {:catch err}
            <div>
                <p>
                    Loading failed
                </p>
                <button data-action="retry" class="flat flat-default" on:click={() => retries++}>retry</button>
            </div>
        {/await}
    </div>
    <div slot="topic" let:topic>

    </div>

    <div slot="footer">
        <Footer {licence}/>
    </div>
</Report>
